import React from 'react';
import './styles/styles.css';
import Header from './components/Header';
import Footer from './components/Footer';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects'; // make sure this is added
import Contact from './components/Contact'; // Add this at the top



function App() {
  return (
    <>
      <Header />
      <main>
      <section className="home-section">
  <div className="home-content">
    <h1 className="home-title">Hi, I'm <span>Saad Ali</span></h1>
    <h2 className="home-subtitle">Frontend Developer & E-commerce Specialist</h2>
    <p className="home-description">
      I craft modern, high-performing websites using React, Shopify, and WordPress. Also experienced in Amazon PPC and project management.
    </p>
    <a href="#projects" className="home-button">View My Work</a>
  </div>
</section>
        <About />
        <Skills />
        <Projects />
        <Contact />

      </main>
      <Footer />
    </>
  );
}

export default App;
